(function initListing() {
    // Listing app
    const Listing = Vue.createApp({
        data() {
            return {
                //defaults
                results: [],
                similarPages: [],
                numResults: 0,
                numPages: 1,
                currentPage: 1
            };
        },

        methods: {
            fetchResults: function () {
                let t = this;

                // get list of saved bookmarks (dependency: ui/bookmarks.js)
                bookmarks.getSavedBookmarks();

                //if (bookmarks.bookmarksList.length > 0) {
                // Get details for pages saved in local storage
                $.getJSON(`/umbraco/api/bookmarksapi/getsavedpages?page=${t.currentPage}&nids=${bookmarks.bookmarksList.join(',')}`, function (data) {
                    t.results = data.results;
                    t.similarPages = data.similarPages;
                    t.numResults = data.numResults;
                    t.numPages = data.numPages;
                    t.currentPage = data.currentPage;

                    if (t.results.length > 0) {
                        setTimeout(function () {
                            if ($('.help-content > div').hasClass('uk-open')) {
                                UIkit.accordion($('.help-content')).toggle(0, false);
                            }
                            bookmarks.setStatus();
                        }, 0);
                    }
                    if (t.currentPage > 1 && t.numPages < t.currentPage){
                        vm.go(t.currentPage - 1);
                    }
                });
                //}
            },

            go: function (n) {
                // switch to page n
                this.currentPage = n;
                this.fetchResults();
            },

            removeBookmark: function (id) {
                bookmarks.removeBookmark(id);
                this.fetchResults();
            }
        },

        created: function () {
            this.fetchResults();
        }
    });
    const vm = Listing.mount('#listing');


})();
